import { showHttpError } from '@calendly/alert'

import { EVENT_TYPE_LIST_TAGS } from 'constants/event_types'
import { removeEventTypeFromListCachesData } from 'features/event_type_editor/cache_updaters'
import { rootApi } from 'root-api'


const getBaseUrl = ({ ownerType, ownerId, eventTypeId }) => ({
  Organization: `/api/organization/event_types/${eventTypeId}`,
  Page: `/api/pages/${ownerId}/event_types/${eventTypeId}`,
  User: `/api/users/${ownerId}/event_types/${eventTypeId}`
}[ownerType])

const api = rootApi.enhanceEndpoints({ addTagTypes: ['PROFILE_EVENT_TYPE_LIST', 'EVENT_TYPE_LIST'] }).injectEndpoints({
  endpoints: (build) => ({
    deleteEventType: build.mutation({
      query: ({ ownerId, ownerType, eventTypeId }) => ({ url: getBaseUrl({ ownerType, ownerId, eventTypeId }), method: 'DELETE' }),
      extraOptions: {
        handleErrors: false
      },
      onQueryStarted: async ({ eventTypeId, uuid, openedEventTypeId, closeEventTypeSidebar }, { queryFulfilled, dispatch, getState }) => {
        try {
          await queryFulfilled

          if (uuid) {
            removeEventTypeFromListCachesData({ api, state: getState(), dispatch, uuid })
          }

          if (String(eventTypeId) === String(openedEventTypeId)) {
            closeEventTypeSidebar()
          }
        } catch (e) {
          dispatch(showHttpError(e.error))
        }
      },
      invalidatesTags: ['WIZARD_METADATA', 'EVENT_TYPES_COLLECTION']
    }),
    cloneEventType: build.mutation({
      query: ({ ownerId, ownerType, eventTypeId }) => (
        { url: `${getBaseUrl({ ownerType, ownerId, eventTypeId })}/clone`, method: 'POST' }
      ),
      onQueryStarted: async ({ onSuccess, shouldInvalidateTags = true }, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled

          if (onSuccess) onSuccess(data)
          if (shouldInvalidateTags) {
            dispatch(api.util.invalidateTags(EVENT_TYPE_LIST_TAGS))
          }
        } catch (e) {
          dispatch(showHttpError(e.error))
        }
      },
    })
  })
})

export const {
  useDeleteEventTypeMutation,
  useCloneEventTypeMutation
} = api
